import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import Toast from './Toast';
import '../styles/UnifiedAuth.css';
import { API_URL } from '../api/config';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { signIn: authSignIn } = useAuth();
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const closeToast = () => {
    setToast({ ...toast, show: false });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  


  const handleSignIn = async () => {
    if (!email || !password) {
      showToast('Please fill in all fields', 'error');
      return;
    }
  
    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/signin`, {
        email,
        password
      });
  
      if (response.data.success) {
        if (response.data.requiresOutletSelection) {
          navigate('/outlet-selection', { state: { outlets: response.data.outlets, email } });
        } else {
          const { token, user } = response.data;
          await authSignIn({ token, user });
          showToast('Signed in successfully');
          navigate('/dashboard'); 
        }
      }
    } catch (error) {
      showToast(error.response?.data?.message || 'An error occurred during sign in', 'error');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="unified-auth-container">
      {toast.show && <Toast message={toast.message} type={toast.type} onClose={closeToast} />}
      
      <div className="auth-form-wrapper">
        <h1 style={{ textAlign: 'center', color: '#8B4513', marginBottom: '5px' }}>TOBO</h1>
        <p style={{ textAlign: 'center', color: '#CD853F', marginBottom: '20px' }}>BILL IT, DONE!</p>

        <p style={{ textAlign: 'center', marginBottom: '20px' }}>
          Enter your registered Email address and password to continue
        </p>

        <div className="form-group">
          <div style={{ position: 'relative' }}>
            <Mail style={{ position: 'absolute', left: '12px', top: '12px', color: '#8B4513' }} size={20} />
            <input
              style={{ paddingLeft: '40px' }}
              placeholder="Enter your email address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none"
            />
          </div>
        </div>

        <div className="form-group">
          <div style={{ position: 'relative' }}>
            <Lock style={{ position: 'absolute', left: '12px', top: '12px', color: '#8B4513' }} size={20} />
            <input
              style={{ paddingLeft: '40px', paddingRight: '40px' }}
              placeholder="Your Password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <div 
              onClick={togglePasswordVisibility}
              style={{ 
                position: 'absolute', 
                right: '12px', 
                top: '12px', 
                color: '#8B4513',
                cursor: 'pointer'
              }}
            >
              {showPassword ? 
                <EyeOff size={20} /> : 
                <Eye size={20} />
              }
            </div>
          </div>
        </div>

        <button
          className="submit-btn"
          onClick={handleSignIn}
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>

        <div className="auth-links">
          <span onClick={() => navigate('/forgot-password')}>
            Forgot password?
          </span>
          <span onClick={() => navigate('/signup')}>
            Create new account
          </span>
        </div>

        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <p style={{ color: '#666', fontSize: '14px' }}>By continuing, you agree to our</p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <a 
              href="https://ocena.in/terms&condition" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: '#8B4513', fontSize: '14px', textDecoration: 'none' }}
            >
              Terms & Conditions
            </a>
            <span style={{ color: '#666' }}>|</span>
            <a 
              href="https://ocena.in/privacy" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ color: '#8B4513', fontSize: '14px', textDecoration: 'none' }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
